import React from "react";
import launch from "./launch.jpg";
import "./tech.css";
const Tech = () => {
  return (
    <div className="techsection">
    <h1 className='meetcrews'><span>03</span>SPACE LAUNCH 101</h1>
      <div className="techmain">
        <div className="left">
          <div className="card">
            <div className="num1">1</div>
            <div className="num">2</div>
            <div className="num">3</div>
          </div>
          <div className='techdata'>
            <h5 className="thetech" style={{color: 'white'}}>THE TECHNOLOGY</h5>
            <h1>LAUNCH ROCKET</h1>
            <p className="techp">A launch rocket is a rocket or a vechile that holds the payload from Earth surface to the space. Our WEB-X is the best and the craziest inovation the human beings has figured out </p>
          </div>
        </div>
        <div  className='imgbox'>
      <img style={{width: '100%', height:'100%', objectFit:"cover"}} src={launch} alt='ans'/>
            </div>
      </div>
    </div>
  );
};

export default Tech;
